import React from "react";
import { useState } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import s from "./mobile-menu.module.scss";

const MobileMenu = (props) => {

    const [mobileMenuItems, setMobileMenuItems] = useState(props.items);

    const setMenu = (name, title) => {
        props.setMenu(name, title);
    }

    const buttons = mobileMenuItems.map(k => <button onClick={setMenu.bind(this, k.name, k.title)}><span>{props.getValue(k.name)}</span></button>);

    const closeMenu = () => {
        props.showMobileMenu(false);
    }


    return (
        <div className={s.MobileMenu}>
            <div className={s.MobileMenuHeader}>
                <button onClick={closeMenu}><CloseIcon /></button>
            </div>
            <div className={s.MobileMenuBody}>
                {buttons}
                <div className={s.otherButtons}>
                    <button className={s.getDemoButton} onClick={setMenu.bind(this, "CONTACTS", "contacts")}>{props.getValue('REQUEST')}</button>
                    <button className={s.enterButton} onClick={setMenu.bind(this, "AUTHORIZATION")}>{props.getValue('ENTER')}</button>
                </div>
                
            </div>
        </div>
    )
}

export default MobileMenu